import React from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { getPurpose, updatePurpose } from "../../store/slice/purposeSlice";
import { toast } from "react-toastify";
import { SidebarComponent } from "../../helpers/commonFunction";

const DeletePurposeModal = ({
  closeDeleteModal,
  deleteModal,
  deletePurposeId,
  setDeleteModal,
  setDeletePurposeId,
}) => {
  const showHideClassName = deleteModal && "user_detail_modal_show";

  const { t } = useTranslation("common");

  const dispatch = useDispatch();
  const sideHeading = localStorage.getItem("sidebar_component");

  const deletePurposeHandler = () => {
    const data = { delete_status: 1 };
    dispatch(
      updatePurpose({
        data,
        id: deletePurposeId,
        cb: (err, res) => {
          if (err) {
            console.log("err", err);
          } else {
            dispatch(getPurpose({}));
            setDeleteModal(false);
            setDeletePurposeId("");
            toast.error(t("toast.delete_purpose"), {
              autoClose: 3000,
            });
          }
        },
      })
    );
  };

  return (
    <>
      <div
        className={`user_detail_modal_bg  ${showHideClassName}`}
        onClick={closeDeleteModal}
      ></div>
      <section
        className={`user_detail_modal_main delete_feedback_modal ${showHideClassName}`}
      >
        <div className="inquiry_complaint_detail_section">
          <h2 className="announcement_page-view-modal">
            Delete {SidebarComponent()}
            {/* {sideHeading} */}
          </h2>
          <h4 className="announcement_page-view-modal delete_feedback_subheading">
            {t("modal.delete.deletePurposeDesc")}
          </h4>
          <div className="delete_feedback_btn-container">
            <button
              type="button"
              onClick={closeDeleteModal}
              className="user_detail_modal_close_btn complaint_view_modalbtn comman_btn secondary_btn"
            >
              {t("common.close")}
            </button>
            <button
              type="button"
              onClick={deletePurposeHandler}
              className="user_detail_modal_close_btn complaint_view_modalbtn comman_btn ml-20"
            >
              {t("common.delete")}
            </button>
          </div>
        </div>
      </section>
    </>
  );
};

export default DeletePurposeModal;
